import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCobrancas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cobrancas', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCredor(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`cobrancas/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCredor(ctx, credorData) {
      return new Promise((resolve, reject) => {
        axios
          .post('cobrancas', { credor: credorData })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
